import React, { useState } from "react";
import Home from "../../pages/Home";
import Pricing from "./../../pages/pricing";
import { Route, Routes, Link } from "react-router-dom";
import AreaCovered from "../../pages/areaCovered";
import Footer from "../footer/footerThree";
import FAQ from "../../pages/faq";
import MyProfile from "./../profile/myProfile/myProfile";
import MyAddress from "../profile/myAddress/myAddress";
import RushMoor from "../rushmoor";
import MyOrders from "../profile/myOrders";
import OrderView from "../profile/orderView";
import AboutUs from "../aboutUs";
import Login from "../login";
import ProductLists from "../productLists";
import CheckOut from "../checkout";
import ForgotPassword from "../forgotPassword";
import AreaNotCovered from "../areaNotCovered";
import GuestLogin from "../guestLogin";
import ResetPassword from "../resetPassword";
import ThankYou from "../thankYou";
import AllNotifications from "../notification/allNotifications";
import EditProfile from "../profile/myProfile/editProfile";
import NewAddress from "../profile/myAddress/newAddress";
import EditAddress from "../profile/myAddress/editAddress";
import TermsAndConditions from "../termsAndConditions";
import PrivacyPolicy from "../privacyPolicy";
import CookiePolicy from "../cookiePolicy";
import ReferFriend from "../profile/referFriend";
import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Navigate } from "react-router-dom";
import PrivateRoute from "./privateRoutes";
import ScrollToTop from "../scrolltoTop/index";
import SignUp from "../signUp";
import Edit from "../edit";
import { getNotification, getSettingsData } from "../../redux/Actions";
import { useDispatch, useSelector } from "react-redux";
import SLoader from "../skeleton";
import Reviews from "../reviews";
import UnderMaintenance from "../underMaintenance";
import ShopList from "../shopList";
import { lazy, Suspense } from 'react';
import Loader from "../loader";
import HeaderTweleve from "../header/headerTweleve";
import FooterTweleve from "../footer/footerTweleve";
import ShoeCleaning from "../theme-tweleve/shoeCleaning";
import HeloLocation from "../theme-tweleve/location";
import HeloAllLocation from "../theme-tweleve/allLocation";
import ShoeRepair from "../theme-tweleve/shoeRepair";
import ProductListsCobbler from "../productCobbler";
import Page404 from "../theme-tweleve/404";
import ShopReviews from "../shopReviews";


const HomeComponent:any = lazy(() => import('../../pages/Home'));
const PricingComponent:any = lazy(() => import('./../../pages/pricing'));
const AreaCoveredComponent:any = lazy(() => import('../../pages/areaCovered'));
const AllNotificationsComponent:any = lazy(() => import('../notification/allNotifications'));
const FAQComponent:any = lazy(() => import('../../pages/faq'));
const UnderMaintenanceComponent:any = lazy(() => import('../underMaintenance'));
const MyProfileComponent:any = lazy(() => import('./../profile/myProfile/myProfile'));
const EditProfileComponent:any = lazy(() => import('../profile/myProfile/editProfile'));
const MyAddressComponent:any = lazy(() => import('../profile/myAddress/myAddress'));
const NewAddressComponent:any = lazy(() => import('../profile/myAddress/newAddress'));
const EditAddressComponent:any = lazy(() => import('../profile/myAddress/editAddress'));
const RushMoorComponent:any = lazy(() => import('../rushmoor'));
const MyOrdersComponent:any = lazy(() => import('../profile/myOrders'));
const OrderViewComponent:any = lazy(() => import('../profile/orderView'));
const AboutUsComponent:any = lazy(() => import('../aboutUs'));
const ReviewsComponent:any = lazy(() => import('../reviews'));
const LoginComponent:any = lazy(() => import('../login'));
const SignUpComponent:any = lazy(() => import('../signUp'));
const ProductListsComponent:any = lazy(() => import('../productLists'));
const CheckOutComponent:any = lazy(() => import('../checkout'));
const ThankYouComponent:any = lazy(() => import('../thankYou'));
const ReferFriendComponent:any = lazy(() => import('../profile/referFriend'));
const ForgotPasswordComponent:any = lazy(() => import('../forgotPassword'));
const AreaNotCoveredComponent:any = lazy(() => import('../areaNotCovered'));
const GuestLoginComponent:any = lazy(() => import('../guestLogin'));
const ResetPasswordComponent:any = lazy(() => import('../resetPassword'));
const TermsAndConditionsComponent:any = lazy(() => import('../termsAndConditions'));
const PrivacyPolicyComponent:any = lazy(() => import('../privacyPolicy'));
const CookiePolicyComponent:any = lazy(() => import('../cookiePolicy'));
const EditComponent:any = lazy(() => import('../edit'));
const ContactUsComponent:any = lazy(() => import('../../pages/contactUs'));
const ShopListComponent:any = lazy(() => import('../shopList'));


function App() {
  const dispatch = useDispatch<any>();
  const settingsData: any = useSelector<any>((state) => state?.settings);
  const [isLoggedIn, setIsLoggedIn] = useState<boolean>(
    () => localStorage.getItem("logged_user") !== null
  );
  const navigate = useNavigate();
  const location = useLocation();
  let url = location.pathname;
  let splitURL: any = url.toString().split("/"); 

  useEffect(() => {
    localStorage.setItem("logged_user", JSON.stringify(isLoggedIn));
  }, [isLoggedIn]);

  useEffect(() => {
    dispatch(getSettingsData());
    if (settingsData?.WebsiteSettings) {
      document.getElementById('favicon')?.setAttribute('href', `${settingsData?.WebsiteSettings?.logo_path + settingsData?.WebsiteSettings?.style_fav}`);
    }
  }, []);

  useEffect(() => {
    let host = window.location.hostname;
    let origin = "https://demo2.bestatlaundry.com";
    let companyName = "";

    if (host !== "localhost") {
      origin = window.location.origin;
      let client = origin.split("/");
      client = client[client.length - 1].split(".");
      companyName = client[0];
      if (settingsData?.WebsiteSettings?.site_status == 0) {
        navigate("/maintenance");
      }
    }

    // if (settingsData?.template == 12) {
      import("../../assets/css/style12.css");
    // }
  }, [settingsData]);

  const checkHeader = () => {
    return (
      splitURL[1] !== "shop" &&
      splitURL[1] !== "edit" &&
      splitURL[1] !== "maintenance" &&
      splitURL[1] !== "edit-shop-home"
    );
  };

  useEffect(() => {
    // localStorage.setItem("postalCode", "GU111BH")
    if (splitURL.length > 3) {
      console.log("shomeapp1")
    }
  }, []);

  return (
    <>
      <title>{settingsData?.WebsiteSettings?.site_title_en}</title>

      <ScrollToTop>
        <SLoader />
        {checkHeader() && settingsData?.template == 12 && <HeaderTweleve />}
        <Suspense fallback={<div><Loader /></div>}>
        <Routes>
          <Route path="/" element={<HomeComponent />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/prices" element={<Pricing />} />
          <Route path="/areaCovered" element={<AreaCovered />} />
          <Route path="/notifications" element={<AllNotifications />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/maintenance" element={<UnderMaintenance />} />
          <Route
            path="/myProfile"
            element={
              <PrivateRoute>
                {" "}
                <MyProfile />{" "}
              </PrivateRoute>
            }
          />
          <Route
            path="/editProfile"
            element={
              <PrivateRoute>
                <EditProfile />
              </PrivateRoute>
            }
          />
          <Route
            path="/myAddress"
            element={
              <PrivateRoute>
                <MyAddress />
              </PrivateRoute>
            }
          />

          <Route
            path="/newAddress"
            element={
              <PrivateRoute>
                <NewAddress />
              </PrivateRoute>
            }
          />
          <Route
            path="/editAddress/:address"
            element={
              <PrivateRoute>
                <EditAddress />
              </PrivateRoute>
            }
          />
          <Route path="/dry-cleaners/:location" element={<RushMoor />} />
          <Route
            path="/myOrders"
            element={
              <PrivateRoute>
                <MyOrders />
              </PrivateRoute>
            }
          />
          <Route
            path="/orderView/:orderId"
            element={
              <PrivateRoute>
                <OrderView />
              </PrivateRoute>
            }
          />
          <Route path="/aboutUs" element={<AboutUs />} />
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/reviews" element={<Reviews />} />
          <Route path="/shopreviews" element={<ShopReviews />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signUp" element={<SignUp />} />
          <Route path="/login/:tokenref" element={<Login />} />
          <Route path="/productLists" element={<ProductLists />} />
          <Route path="/product-lists" element={<ProductListsCobbler />} />
          <Route path="/404" element={<Page404 />} />
          <Route path="/checkOut" element={<CheckOut />} />

          {/* shop home routes */}
          <Route
            path="/shop/:finalResult/productLists"
            element={<ProductLists />}
          />
          <Route path="/shop/:finalResult/checkOut" element={<CheckOut />} />
          <Route path="/shop/:finalResult/thankYou" element={<ThankYou />} />
          <Route
            path="/shop/:finalResult/orderView/:orderId"
            element={
              <PrivateRoute>
                <OrderView />
              </PrivateRoute>
            }
          />
          <Route
            path="/shop/:finalResult/myOrders"
            element={
              <PrivateRoute>
                <MyOrders />
              </PrivateRoute>
            }
          />
          <Route
            path="/shop/:finalResult/myProfile"
            element={
              <PrivateRoute>
                {" "}
                <MyProfile />{" "}
              </PrivateRoute>
            }
          />
          <Route
            path="/shop/:finalResult/referFriend"
            element={
              <PrivateRoute>
                {" "}
                <ReferFriend />{" "}
              </PrivateRoute>
            }
          />
          <Route
            path="/shop/:finalResult/myAddress"
            element={
              <PrivateRoute>
                <MyAddress />
              </PrivateRoute>
            }
          />
          <Route path="/shop/:finalResult/pricing" element={<Pricing />} />
          <Route path="/shop/:finalResult/areaCovered" element={<AreaCovered />} />
          <Route path="/shop/:finalResult/faq" element={<FAQ />} />
          <Route path="/shop/:finalResult/aboutUs" element={<AboutUs />} />
          <Route path="/shop/:finalResult/privacyPolicy" element={<PrivacyPolicy />} />
          <Route path="/shop/:finalResult/termsAndConditions" element={<TermsAndConditions />} />
          {/* shop home routes */}

          <Route path="/forgotPassword" element={<ForgotPassword />} />
          <Route path="/areaNotCovered" element={<AreaNotCovered />} />
          <Route path="/guestLogin" element={<GuestLogin />} />
          <Route path="/resetPassword/:token" element={<ResetPassword />} />
          <Route path="/thankYou" element={<ThankYou />} />
          <Route path="/termsAndConditions" element={<TermsAndConditions />} />
          <Route path="/terms-conditions" element={<TermsAndConditions />} />
          <Route path="/privacyPolicy" element={<PrivacyPolicy />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/cookiePolicy" element={<CookiePolicy />} />
          <Route path="/cookie-policy" element={<CookiePolicy />} />
          <Route path="/referFriend" element={<ReferFriend />} />
          <Route path="/edit" element={<Edit />} />
          <Route path='/shoplist' element={<ShopList />} />
          <Route path="/shoe-cleaning" element={<ShoeCleaning/>}/>
          <Route path="/shoe-repair" element={<ShoeRepair/>}/>
          <Route path="/location/:location" element={<HeloLocation/>}/>
          <Route path="/all-location" element={<HeloAllLocation/>}/>
          
        </Routes>
        </Suspense>
        {checkHeader() && settingsData?.template == 12 && <FooterTweleve />}
      </ScrollToTop>
    </>
  );
}

export default App;
